export default "__VITE_ASSET__9613b873__"